import { useMutation, useQueryClient } from "react-query";

import { crearRegistroSalida, updateRegistroSalida, deleteRegistroSalida} from '../../services/RegistroSalidas';

import { toast } from 'react-hot-toast';
const queryKey = "salidas";

export const useSalidasMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
   // toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addSalida = useMutation((body) => crearRegistroSalida(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateSalidaD = useMutation(
    (body) => updateRegistroSalida( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeSalida = useMutation((id) => deleteRegistroSalida( id), {
    onSuccess,
    onError,
  });

  return { addSalida, updateSalidaD, removeSalida };
};
export default useSalidasMutations;